import script from "./ClubEventTournamentType.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTournamentType.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTournamentType.vue?vue&type=style&index=0&id=b824ab9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b824ab9e"]])

export default __exports__